import Vue from 'vue';
import App from './App.vue';

// فعالسازی مسیریابی ها
import VueRouter from 'vue-router';

// اعتبارسنجی مقادیر سند
import vuelidate from 'vuelidate';

// جهت نمایش جدا کننده سه رقم سه رقم در سند استفاده شده است
import numFormat from 'vue-filter-number-format';

// جهت جداکننده ممیز تاریخ در ثبت سند استفاده شده است
// npm i -S vue-the-mask
import VueTheMask from 'vue-the-mask';

// نمایش تقویم شمسی
// npm install vue-persian-datetime-picker --save
// https://talkhabi.github.io/vue-persian-datetime-picker
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

// کتابخانه تبدیل تاریخ شمسی به میلادی و بالعکس
// https://www.npmjs.com/package/shamsi-date-converter
// npm install shamsi-date-converter -S
// var shamsi = require('shamsi-date-converter');
// shamsi.gregorianToJalali('July 17, 1995 03:24:00'); //[1374, 4, 26]

// Vue.http
// فعالسازی امکان اتصال به ای پی آی های بکند http api
import VueResuorce from 'vue-resource';

// جهت ذخیره و بازیابی کوکی
import VueCookie from 'vue-cookie';

// فراخوانی تنظیمات روتینگ
import { appRoutes } from './Routes.js';

// فراخوانی مخزن نگهداری اطلاعات
import { appStore } from './Store/Store.js';

// فراخوانی sweet
// جهت نمایش پیام به کاربر
// https://sweetalert.js.org/guides
import swal from 'sweetalert';

// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Vue.use(BootstrapVue)
// Vue.use(IconsPlugin)

// مربوط به فراخوانی و فعالسازی دستورات جیکوئری
window.$ = window.jQuery = require('./assets/js/jquery-3.4.1.min.js');

// مربوط به تایمر صفحه محدودیت دسترسی
import VueCountdownTimer from 'vuejs-countdown-timer';
Vue.use(VueCountdownTimer);

Vue.use(VueRouter);
Vue.use(vuelidate);
Vue.use(VueTheMask);
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.filter('numFormat', numFormat);
Vue.use(VueResuorce);
Vue.use(VueCookie);

// آدرس اتصال به سرور محلی
// Vue.http.options.root = "http://localhost:61515/api/";
// Vue.http.options.root = "https://localhost:44369/api/";

// آدرس اتصال به سیستم محمد آقا
// Vue.http.options.root = "http://marketing-pc:8080/api/";

// آدرس اتصال به سرور پرش
Vue.http.options.root = "https://accapi.parsrayanehco.ir/api/";

// آدرس اتصال به سرور افتا
// Vue.http.options.root = "http://localhost:8080/api/";
// Vue.http.options.root = "http://192.168.35.117:8080/api/";
// Vue.http.options.root = "https://192.168.35.117:8081/api/";

// کلمه export به این خاطر که از سایر کامپاننت ها بتوان روت را استفاده کرد
export const newRoutes = new VueRouter({
    routes: appRoutes,
    mode: 'history',
    // کد زیر باعث می شود در مراجعه به صفحه جدید
    // اسکرول به بالای صفحه منتقل شود
    // scrollBehavior() {
    //     return {
    //         x: 0,
    //         y: 0
    //     };
    // }
});

// تعریف یک باس ایونت جهت مدیریت رویدادهای عمومی
export const BusEvent = new Vue();

new Vue({
    el: '#app',
    store: appStore,
    router: newRoutes,
    render: h => h(App)
})

// پس از کلون کردن پروژه از روی ریپازیتوری
// و در اولین اجرای برنامه توسط npm run dev
// خطایی بروز می کند به شکل زیر
// 'cross-env' is not recognized as an internal or external command,
// operable program or batch file.
// جهت رفع این خطا دستور زیر باید اجرا شود
// npm install --save-dev cross-env


// WEBPACK FOOTER //
// ./src/main.js